<template>
   <CookieControlNotin id="cookies" :locale="store.idioma" >
    <template #bar v-if="store.NOTARIA.CookiesBaner">
      <h2>Cookies</h2>
      <p v-html="store.NOTARIA.CookiesBaner"></p>
    </template>
   </CookieControlNotin>
</template>

<script setup lang="ts">
// La gestión de gtag/Consent Mode al aceptar o rechazar está en CookieControlNotin.vue
import CookieControlNotin from './CookieControlNotin.vue';
import { useStore } from '../../store/index'
const store = useStore();
</script>
<style>

.cookieControl__BarContainer h2{
  color: black;
}

</style>